var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import Template_1 from './Templates/1';
import Template_2 from './Templates/2';
import Template_3 from './Templates/3';
import Template_4 from './Templates/4';
import Template_5 from './Templates/5';
import Template_6 from './Templates/6';
import Template_7 from './Templates/7';
import Template_8 from './Templates/8';

var Template = function (_Component) {
    _inherits(Template, _Component);

    function Template(props) {
        _classCallCheck(this, Template);

        var _this = _possibleConstructorReturn(this, (Template.__proto__ || Object.getPrototypeOf(Template)).call(this, props));

        _this.getFontSize = function (text) {
            var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var maxLength = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
            var fontSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 14;

            if (!text) return '15px'; // default

            // if(minLength && maxLength && text.length >= minLength && text.length <= maxLength){
            //     return fontSize + 'px';
            // }else if(minLength && text.length >= minLength){
            //     return fontSize + 'px';
            // }else if(maxLength && text.length <= maxLength){
            //     return fontSize + 'px';
            // }

            if (text.length > 20 && text.length < 26) {
                return '16px';
            } else if (text.length > 26) {
                return '15px';
            }
        };

        _this.state = {
            values: _this.props.values
        };
        return _this;
    }

    _createClass(Template, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {}
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                values = _props.values,
                selectedTemplate = _props.selectedTemplate,
                validWebsiteURL = _props.validWebsiteURL,
                validImageURL = _props.validImageURL,
                validEmail = _props.validEmail,
                fetchingTweets = _props.fetchingTweets,
                fetchingInstagram = _props.fetchingInstagram;

            var params = { getFontSize: this.getFontSize, values: values, validWebsiteURL: validWebsiteURL, validImageURL: validImageURL, validEmail: validEmail, fetchingTweets: fetchingTweets, fetchingInstagram: fetchingInstagram };
            var currentTemplate = '';

            switch (selectedTemplate) {
                case '0':
                    {
                        currentTemplate = React.createElement(Template_1, params);
                        break;
                    }
                case '1':
                    {
                        currentTemplate = React.createElement(Template_2, params);
                        break;
                    }
                case '2':
                    {
                        currentTemplate = React.createElement(Template_3, params);
                        break;
                    }
                case '3':
                    {
                        currentTemplate = React.createElement(Template_4, params);
                        break;
                    }
                case '4':
                    {
                        currentTemplate = React.createElement(Template_5, params);
                        break;
                    }
                case '5':
                    {
                        currentTemplate = React.createElement(Template_6, params);
                        break;
                    }
                case '6':
                    {
                        currentTemplate = React.createElement(Template_7, params);
                        break;
                    }
                case '7':
                    {
                        currentTemplate = React.createElement(Template_8, params);
                        break;
                    }
            }

            return React.createElement(
                'div',
                null,
                currentTemplate
            );
        }
    }]);

    return Template;
}(Component);

export default Template;


// WEBPACK FOOTER //
// ./node_modules/@int/signature/lib/containers/app/Template.js